import { fadeInScaleUpTransition as r } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { fadeInTransition as i } from "../../../_styles/transitions/fade-in.cssr.js";
import { c as e, cB as o, cNotM as t } from "../../../_utils/cssr/index.js";
const l = e([e("body >", [o("image-container", "position: fixed;")]), o("image-preview-container", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 `), o("image-preview-overlay", `
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background: rgba(0, 0, 0, .3);
 `, [i()]), o("image-preview-toolbar", `
 z-index: 1;
 position: absolute;
 left: 50%;
 transform: translateX(-50%);
 border-radius: var(--n-toolbar-border-radius);
 height: 48px;
 bottom: 40px;
 padding: 0 12px;
 background: var(--n-toolbar-color);
 box-shadow: var(--n-toolbar-box-shadow);
 color: var(--n-toolbar-icon-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [o("base-icon", `
 padding: 0 8px;
 font-size: 28px;
 cursor: pointer;
 `), i()]), o("image-preview-wrapper", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 pointer-events: none;
 `, [r()]), o("image-preview", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: all;
 margin: auto;
 max-height: calc(100vh - 32px);
 max-width: calc(100vw - 32px);
 transition: transform .3s var(--n-bezier);
 `), o("image", `
 display: inline-flex;
 max-height: 100%;
 max-width: 100%;
 `, [t("preview-disabled", `
 cursor: pointer;
 `), e("img", `
 border-radius: inherit;
 `)])]);
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/src/styles/index.cssr.js
// module id = 1653
// module chunks = 41